import { createElement } from '@syncfusion/ej2-base';
export class ParagraphRenderer {
    constructor(manager) {
        this.parent = manager;
    }
    /**
     * Renders paragraph block
     *
     * @param {BlockModel} block - specifies the block.
     * @returns {HTMLElement} - the created or updated element
     * @hidden
     */
    renderParagraph(block) {
        const paragraphProps = block.properties;
        paragraphProps.placeholder = this.parent.getPlaceholderValue(block);
        const paragraph = createElement('p', {
            attrs: {
                contenteditable: 'true',
                placeholder: paragraphProps.placeholder
            }
        });
        this.parent.blockRenderer.contentRenderer.renderContent(block, paragraph);
        return paragraph;
    }
}
